import React from "react";

import { Button, Modal } from "shared/ui";

import { useTablesManagementContext } from "features/TablesManagement/context";

export const DeleteTableDialog = () => {
    const state = useTablesManagementContext();
    const { tableToDelete } = state;

    const title = tableToDelete
        ? tableToDelete.title[state.locale] ||
          Object.values(tableToDelete.title).find((value) => !!value)
        : "";

    return (
        <Modal
            open={!!tableToDelete}
            onClose={state.closeDeleteDialog}
            title="Удаление стола"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={state.closeDeleteDialog}>
                        Отмена
                    </Button>
                    <Button
                        variant="contained"
                        color="danger"
                        disabled={state.saving}
                        onClick={state.confirmDelete}
                    >
                        Удалить
                    </Button>
                </>
            }
        >
            Удалить стол №{tableToDelete?.publicId}
            {title ? ` «${title}»` : ""}? Гости больше не смогут выбрать его при заказе, а
            QR-код этого стола перестанет работать.
        </Modal>
    );
};
